import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setExpandMenu } from "../../data/redux/commonSlice";
import { RootState } from "../../data/redux/store";
import { SidebarData } from "../../data/json/sidebarData";

const Sidebar = () => {
  const Location = useLocation();
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state: RootState) => state.permission.permissions
  );

  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const toggle = () => {
    dispatch(setExpandMenu(true));
  };
  const toggle2 = () => {
    dispatch(setExpandMenu(false));
  };

  useEffect(() => {
    setSubopen(localStorage.getItem("menuOpened"));
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={toggle}
        onMouseLeave={toggle2}
      >
        <Scrollbars>
          <div
            className="card"
            style={{
              margin: "8px",
              boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.2)", // Shadow on the right and bottom
              borderRadius: "8px", // Optional for rounded corners
              overflow: "hidden", // Ensures content stays inside the card
            }}
          >
            <div className="card-body">
              <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                  <ul>
                    {SidebarData?.map((mainLabel, index) => {
                      // Check if the main menu should be visible based on permissions
                      const isMainMenuVisible = mainLabel?.submenuItems?.some(
                        (submenuItem: any) =>
                          permissions.includes(submenuItem.title)
                      );

                      // Skip rendering this main menu if the user lacks permissions
                      if (!isMainMenuVisible) {
                        return null;
                      }

                      return (
                        <li className="clinicdropdown" key={index}>
                          <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                          <ul>
                            {mainLabel?.submenuItems?.map(
                              (submenuItem: any, i) => {
                                // Check if the current submenu item should be visible
                                if (!permissions.includes(submenuItem.title)) {
                                  return null;
                                }

                                return (
                                  <li
                                    className="submenu"
                                    key={submenuItem.label}
                                  >
                                    <Link
                                      to={
                                        submenuItem?.submenu
                                          ? "#"
                                          : submenuItem?.link
                                      }
                                      className={`${
                                        submenuItem?.link ===
                                        window.location.pathname
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <i className={submenuItem.icon}></i>
                                      <span>{submenuItem?.label}</span>
                                      {submenuItem?.submenu && (
                                        <span className="menu-arrow" />
                                      )}
                                    </Link>
                                    {submenuItem?.submenuItems && (
                                      <ul>
                                        {submenuItem?.submenuItems?.map(
                                          (subSubItem: any) => {
                                            // Check if the subsubmenu item is allowed
                                            if (
                                              !permissions.includes(
                                                subSubItem.title
                                              )
                                            ) {
                                              return null;
                                            }

                                            return (
                                              <li key={subSubItem.label}>
                                                <Link
                                                  to={subSubItem.link}
                                                  className={`${
                                                    subSubItem.link ===
                                                    window.location.pathname
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                >
                                                  {subSubItem.label}
                                                </Link>
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                );
                              }
                            )}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
